import Vue from 'vue';
function percentageFilter(value) {
  if (value === null || value === undefined || value === '') return '';
  return value === '--' ? value : value + '%';
}

Vue.filter('percentage', percentageFilter);

export default percentageFilter;
